import {Check} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const CheckIcon = createLucideIcon(Check, 'CheckIcon');
